export const base64ToPdfBlobUrl = (base64file = ''): string => {
  const byteCharacters = window.atob(base64file);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  return blobUrl;
};
